import { create } from 'zustand';
import type { CallsView } from '@/lib/callsQuery';
import { dayKey } from '@/lib/calendarDates';

/**
 * Выбор на экранах «Звонки» и «Календарь» переживает переход между вкладками
 * (экран при уходе размонтируется, а человек ждёт, что вернётся туда же).
 */
interface WorkUi {
  calls: CallsView;
  setCalls: (patch: Partial<CallsView>) => void;
  /** Выбранный день ГГГГ-ММ-ДД. */
  calDay: string;
  calMonth: boolean;
  /** me — мой календарь, all — вся команда, иначе id человека. */
  calWho: string;
  setCal: (patch: Partial<Pick<WorkUi, 'calDay' | 'calMonth' | 'calWho'>>) => void;
}

export const useWorkUi = create<WorkUi>((set) => ({
  calls: { kind: 'all', period: 'week', mine: true },
  setCalls: (patch) => set((s) => ({ calls: { ...s.calls, ...patch } })),
  calDay: dayKey(new Date()),
  calMonth: false,
  calWho: 'me',
  setCal: (patch) => set(patch),
}));
